<!-- モーダルオーバーレイ -->
<div class="modal-overlay" *ngIf="isOpen" (click)="close()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- ヘッダー -->
    <div class="modal-header">
      <h3>{{ title }}</h3>
      <button class="close-button" (click)="close()" [title]="i18n.t('drivePicker.close')">×</button>
    </div>

    <!-- 検索バー -->
    <div class="search-bar">
      <input
        type="text"
        class="search-input"
        [placeholder]="i18n.t('drivePicker.searchPlaceholder')"
        [(ngModel)]="searchQuery"
        (input)="onSearchChange()"
        [disabled]="isLoading">
      <div class="search-icon">🔍</div>
    </div>

    <!-- ローディング状態 -->
    <div class="loading-state" *ngIf="isLoading">
      <div class="loading-spinner"></div>
      <p>{{ i18n.t('drivePicker.loading') }}</p>
    </div>

    <!-- 画像グリッド -->
    <div class="images-grid" *ngIf="!isLoading && filteredImages.length > 0">
      <div
        *ngFor="let image of filteredImages; trackBy: trackByImageId"
        class="image-item"
        [class.selected]="selectedImage?.imageId === image.imageId"
        (click)="selectImage(image)">
        
        <div class="image-container">
          <img [src]="image.thumbnailUrl || image.imageUrl" [alt]="image.prompt" class="image-thumbnail">
          <div class="image-overlay" *ngIf="selectedImage?.imageId === image.imageId">
            <div class="check-icon">✓</div>
          </div>
        </div>

        <div class="image-info">
          <p class="image-prompt" [title]="image.prompt">
            {{ truncatePrompt(image.prompt) }}
          </p>
          <p class="image-date">{{ formatDate(image.generatedDate) }}</p>
        </div>
      </div>
    </div>

    <!-- 空の状態 -->
    <div class="empty-state" *ngIf="!isLoading && filteredImages.length === 0">
      <div class="empty-icon">📁</div>
      <h4>{{ i18n.t('drivePicker.noImages') }}</h4>
      <p *ngIf="searchQuery">{{ i18n.t('drivePicker.noSearchResults') }}</p>
      <p *ngIf="!searchQuery">{{ i18n.t('drivePicker.noAvailable') }}</p>
    </div>

    <!-- フッター -->
    <div class="modal-footer">
      <button
        class="spectrum-button spectrum-button--secondary"
        (click)="close()"
        [disabled]="isLoading">
        {{ i18n.t('drivePicker.cancel') }}
      </button>
      <button
        class="spectrum-button spectrum-button--primary"
        (click)="confirmSelection()"
        [disabled]="!selectedImage || isLoading">
        {{ isLoading ? i18n.t('drivePicker.processing') : i18n.t('drivePicker.select') }}
      </button>
    </div>
  </div>
</div>